import { render, staticRenderFns } from "./LogisticsEdit.vue?vue&type=template&id=daad0060&scoped=true"
import script from "./LogisticsEdit.vue?vue&type=script&lang=js"
export * from "./LogisticsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daad0060",
  null
  
)

export default component.exports